import withComponent from "../../../hoc/withComponent";
import {useCallback, useEffect, useMemo, useRef, useState} from "react";
import TranlateBox from "../TranlateBox";
import useForceUpdate from "../../../hooks/useForceUpdate";
import {v4} from "uuid";
import "@/styled/FlexStyled";
import FlexStyled from "@/styled/FlexStyled"
import {Scrollbars} from 'react-custom-scrollbars';
import resumeDataSlice from "@/components/resume/redux/services/resumeDataSlice";
import {message, Popover} from "antd"

import {
    ChatItemLayoutStyled,
    ContainerStyled,
    DivStyled1,
    DivStyled10, DivStyled11, DivStyled12, DivStyled13, DivStyled14, DivStyled15, DivStyled16, DivStyled17, DivStyled18,
    DivStyled2, DivStyled20,
    DivStyled3,
    DivStyled4,
    DivStyled5,
    DivStyled7,
    DivStyled8,
    DivStyled9,
    InputContainerStyled,
    InputEnterIconStyled,
    InputIconStyled,
    InputPositionStyled,
    InputStyled,
    JzButton,
    JzButtonIcon,
    MessageContainerStyled,
    MessageScrollContainerStyled,
    SystemChatBoxStyled,
    SystemChatTextStyled,
    UserChatBoxPositionStyled,
    UserChatBoxStyled,
    UserChatTextStyled
} from "./styled"
import {getIconByModule} from "@/common/resume/getIconByModule";
import getTextByModule from "@/common/module/getTextByModule";
import {icon1, icon2, redoIcon, undoIcon, whiteRedoIcon} from "@/pages/ResumeDetail/Chat/icon";
import aiDecisionSlice from "@/components/resume/redux/services/aiDecisionSlice";
import getResumePath from "@/common/resume/getResumePath";
import {useResumeDispatch, useResumeSelector, useSelector} from "@/components/resume/redux/hooks";

import getTextBySlot from "@/common/slot/getTextBySlot";
import getNestedProperty from "@/utils/getNestedProperty";
import getResumeDataExcludeIcon from "@/common/getResumeDataExcludeIcon";
import {modifyResume} from "@/http/api";
import getFieldBySlot from "@/common/module/getFieldBySlot";
import useResumeDetailInstance from "@/pages/ResumeDetail/hooks/useResumeDetailInstance";
import usAiDecision from "@/components/resume/hooks/usAiDecision";
import {errorCallbackObj} from "@/components/ErrorModal";
import SelectCard from "./components/SelectCard";
import ResumeStyler from "./components/ResumeStyler";
import sleep from "@/utils/sleep";
import resumeSlice from "@/components/resume/redux/services/resumeSlice";
import SelectNextCard from "./components/SelectNextCard";
import Dialog from "@/components/Dialog";
import useClickOutside from "../hooks/useClickOutside";


const helpIcon = <div style={{
    width: 18,
    height: 18,
    display: 'inline-block',
    position: 'relative',
    top: 2,
    marginRight: 8,
}} dangerouslySetInnerHTML={{
    __html: `<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="简历编辑页" transform="translate(-1206.000000, -108.000000)" fill="#151515" fill-rule="nonzero">
            <g id="chatgpt备份" transform="translate(1206.000000, 108.000000)">
                <path d="M11.7654797,11.8 L12.4578816,11.8 C12.589975,11.7673395 12.7217056,11.6348832 12.7217056,11.5031526 L12.7217056,8.89684736 C12.6890451,8.76475392 12.5569517,8.66604672 12.3918349,8.66604672 L11.6990701,8.66604672 C11.5653846,8.70370662 11.4718164,8.82405064 11.4682694,8.96289409 L11.4682694,11.536176 C11.5009299,11.7009299 11.6330234,11.8 11.7651168,11.8 L11.7654797,11.8 Z M6.71762306,8.66604672 L6.02485824,8.66604672 C5.89117273,8.70370662 5.79760452,8.82405064 5.79405761,8.96289409 L5.79405761,11.536176 C5.82671808,11.6679066 5.95881152,11.7669767 6.09090497,11.7669767 L6.78366977,11.7669767 C6.91540032,11.7343162 7.04749377,11.6022227 7.04749377,11.4701293 L7.04749377,8.863824 C7.01483331,8.76475392 6.88273987,8.66604672 6.71762306,8.66604672 L6.71762306,8.66604672 Z" id="形状"></path>
                <path d="M10.1192243,13.7135405 L6.22718531,13.7135405 L3.02645952,12.8886822 L3.02645952,7.57736448 L6.19379905,6.7855296 L7.1834112,5.79591745 L7.21607167,5.76289409 C7.24945793,5.72987074 7.24945793,5.69684736 7.24945793,5.66382401 C7.24945793,5.63080065 7.24945793,5.56475392 7.21643458,5.56475392 C7.18341122,5.53209346 7.15038785,5.53209346 7.11736449,5.53209346 L6.29250624,5.53209346 L7.11736449,5.53209346 L6.16077569,5.53209346 L6.02868225,5.56475392 L2.36708097,6.48868224 L2.33369473,6.48868224 L2.20196418,6.55436608 C1.90511681,6.68682241 1.74,7.01633024 1.74,7.37922431 L1.74,13.2515763 C1.77266047,13.5818099 2.00382399,13.845271 2.30067135,13.9773645 L2.43276481,14.010025 L2.63090498,14.0764346 L2.72961216,14.109095 L2.82868224,14.1424813 L5.96263552,14.9669766 L5.99565888,14.9669766 L6.12775234,15 L9.29472897,15 L10.2516807,14.0434112 C10.2843411,14.0103879 10.3173645,13.9773645 10.3173645,13.9113178 C10.284704,13.7795872 10.2186573,13.7135405 10.1195872,13.7135405 L10.1192243,13.7135405 Z M16.2557632,7.37922431 C16.2557632,7.04935359 16.0906464,6.75250623 15.8268224,6.58738944 L15.7277523,6.52170561 L15.6620685,6.48868224 L15.5960218,6.45565889 L12.0661511,5.53173055 L12.0331277,5.53173055 L11.9010343,5.49907008 L11.0104922,5.49907008 C10.9485792,5.46753866 10.9101084,5.40342069 10.9114221,5.33395329 L10.9114221,5.30092992 C10.9114221,5.26790656 10.9440826,5.23488319 10.9440826,5.20185983 C11.2082695,4.64118848 11.8019642,3.48645951 11.9340576,3.22263552 C11.9340576,3.18961216 11.9667181,3.18961216 11.9667181,3.15658881 C11.9667181,3.09054208 11.9340576,3.05751872 11.9010343,3.02449535 C11.8683738,2.99183488 11.8019642,2.99183488 11.7359174,3.02449535 L10.6472352,3.61855297 L8.80010433,5.4987072 L8.93183488,5.36697664 L8.66801089,5.63080064 L8.70067136,5.59814017 L8.07431618,6.22449536 C7.9752461,6.32356545 7.94222274,6.45565889 8.00826945,6.55472897 C8.04092992,6.68645952 8.17302336,6.75250625 8.30511682,6.75250625 L11.8349875,6.75250625 L15.0349875,7.57736448 L15.0349875,12.8886822 L11.8680109,13.7135405 L10.8783987,14.7031527 L10.8453754,14.7358131 C10.812352,14.7691994 10.812352,14.8352461 10.8453754,14.9009299 C10.8780358,14.9669766 10.9444455,14.9669766 10.9774688,14.9669766 L11.9010343,14.9669766 L12.0331277,14.9343162 L15.2991744,14.0764346 L15.3318349,14.0764346 L15.5629984,14.0103878 L15.6620685,13.9773645 C16.0249626,13.845271 16.2557632,13.482377 16.2557632,13.0864595 L16.2557632,7.37995011 L16.2557632,7.37922431 Z" id="形状"></path>
            </g>
        </g>
    </g>
</svg>`
}}/>
const inputIcon = <div style={{width: 26, height: 26}} dangerouslySetInnerHTML={{
    __html: `<svg width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="简历编辑页" transform="translate(-1202.000000, -1205.000000)" fill="#66D3C5" fill-rule="nonzero">
            <g id="编组-4" transform="translate(1190.000000, 1194.000000)">
                <g id="秒出助手" transform="translate(12.000000, 11.000000)">
                    <path d="M16.9945818,15.6 L17.9947179,15.6 C18.1855195,15.5528238 18.375797,15.3614979 18.375797,15.1712205 L18.375797,11.4065573 C18.3286208,11.2157557 18.1378191,11.0731786 17.8993171,11.0731786 L16.8986568,11.0731786 C16.7055555,11.1275762 16.5704014,11.3014065 16.5652781,11.5019581 L16.5652781,15.2189209 C16.6124543,15.4568988 16.803256,15.6 16.9940576,15.6 L16.9945818,15.6 Z M9.7032333,11.0731786 L8.70257302,11.0731786 C8.50947173,11.1275762 8.37431764,11.3014065 8.36919432,11.5019581 L8.36919432,15.2189209 C8.41637056,15.4091984 8.60717219,15.5522996 8.79797385,15.5522996 L9.79863411,15.5522996 C9.98891157,15.5051234 10.1797132,15.3143217 10.1797132,15.1235201 L10.1797132,11.3588569 C10.132537,11.2157557 9.94173536,11.0731786 9.7032333,11.0731786 L9.7032333,11.0731786 Z" id="形状"></path>
                    <path d="M14.6166574,18.3640029 L8.99482322,18.3640029 L4.37155264,17.172541 L4.37155264,9.50063758 L8.94659862,8.35687609 L10.3760384,6.92743631 L10.4232146,6.87973591 C10.4714392,6.83203551 10.4714392,6.78433508 10.4714392,6.73663468 C10.4714392,6.68893428 10.4714392,6.59353345 10.4237388,6.59353345 C10.3760384,6.54635722 10.328338,6.54635722 10.2806376,6.54635722 L9.08917568,6.54635722 L10.2806376,6.54635722 L8.89889822,6.54635722 L8.70809659,6.59353345 L3.41911696,7.92809657 L3.37089238,7.92809657 L3.18061492,8.02297323 C2.7518354,8.21429903 2.51333333,8.69025479 2.51333333,9.21443512 L2.51333333,17.6967214 C2.56050956,18.1737255 2.89441243,18.5542804 3.32319196,18.745082 L3.51399362,18.7922583 L3.80019608,18.8881833 L3.94277312,18.9353595 L4.08587435,18.9835841 L8.61269576,20.1745218 L8.66039616,20.1745218 L8.85119782,20.2222222 L13.4257196,20.2222222 L14.8079832,18.8404829 C14.8551594,18.7927825 14.9028598,18.745082 14.9028598,18.6496812 C14.8556836,18.4594037 14.7602828,18.3640029 14.6171815,18.3640029 L14.6166574,18.3640029 Z M23.4805469,9.21443512 C23.4805469,8.73795519 23.2420448,8.30917567 22.8609657,8.07067363 L22.7178645,7.975797 L22.6229878,7.92809657 L22.527587,7.88039617 L17.4288849,6.54583302 L17.3811845,6.54583302 L17.1903828,6.49865679 L15.9040443,6.49865679 C15.8146144,6.4531114 15.7590455,6.36049655 15.760943,6.26015475 L15.760943,6.21245432 C15.760943,6.16475392 15.8081193,6.11705349 15.8081193,6.06935309 C16.1897226,5.25949447 17.0472816,3.59155262 17.2380832,3.21047353 C17.2380832,3.16277312 17.2852595,3.16277312 17.2852595,3.11507272 C17.2852595,3.01967189 17.2380832,2.97197149 17.1903828,2.92427106 C17.1432066,2.87709483 17.0472816,2.87709483 16.9518808,2.92427106 L15.3793397,3.78235428 L12.7112618,6.49813262 L12.9015393,6.30785515 L12.5204602,6.68893425 L12.5676364,6.64175802 L11.6629012,7.5464933 C11.5197999,7.68959453 11.4720995,7.88039617 11.5675003,8.0234974 C11.6146766,8.21377486 11.8054782,8.30917569 11.9962798,8.30917569 L17.094982,8.30917569 L21.7172042,9.50063758 L21.7172042,17.172541 L17.1426824,18.3640029 L15.7132426,19.7934427 L15.6655422,19.840619 C15.6178418,19.8888436 15.6178418,19.9842444 15.6655422,20.079121 C15.7127184,20.1745218 15.8086434,20.1745218 15.8563438,20.1745218 L17.1903828,20.1745218 L17.3811845,20.1273456 L22.0988075,18.8881833 L22.1459837,18.8881833 L22.4798866,18.7927824 L22.6229878,18.745082 C23.1471682,18.5542804 23.4805469,18.0301 23.4805469,17.4582193 L23.4805469,9.21548349 L23.4805469,9.21443512 Z" id="形状"></path>
                </g>
            </g>
        </g>
    </g>
</svg>`
}}/>
const enterIcon = <div style={{width: 18, height: 18}} dangerouslySetInnerHTML={{
    __html: `<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="简历编辑页" transform="translate(-1555.000000, -1209.000000)" fill="#C4C4C4">
            <g id="编组-4" transform="translate(1190.000000, 1194.000000)">
                <g id="秒出助手备份" transform="translate(365.000000, 15.000000)">
                    <g id="send-2" transform="translate(1.000000, 1.040000)">
                        <path d="M16,0.599363591 L16,0.532767636 C16,0.466171682 15.933404,0.399575727 15.933404,0.332979773 C15.933404,0.332979773 15.933404,0.266383818 15.8668081,0.266383818 C15.8668081,0.199787864 15.8002121,0.199787864 15.8002121,0.133191909 L15.7336162,0.133191909 C15.7336162,0.133191909 15.6670202,0.133191909 15.6670202,0.0665959545 L15.6004243,0.0665959545 L15.5338283,0.0665959545 L15.4672324,0.0665959545 C15.4006364,0 15.3340405,0 15.3340405,0 L15.2674445,0 L15.2008485,0 C15.1342526,0 15.1342526,0 15.0676566,0.0665959545 L15.0010607,0.0665959545 L0.349950686,7.39215095 C0.0835668677,7.52534286 -0.0496250413,7.79172668 0.0169709132,8.0581105 C0.0835668677,8.32449432 0.283354731,8.59087813 0.549738549,8.59087813 L4.54549582,9.25683768 L4.67868773,9.25683768 C4.81187964,9.25683768 4.94507155,9.19024172 5.07826346,9.12364577 L10.8721115,4.79490873 L6.80975828,9.5232215 C6.74316232,9.58981745 6.74316232,9.65641341 6.67656637,9.72300936 L6.67656637,15.2504736 C6.67656637,15.5834534 6.87635423,15.8498372 7.209334,15.9164331 L7.34252591,15.9164331 C7.60890973,15.9164331 7.80869759,15.7832412 7.9418895,15.5834534 L9.60678837,12.5866354 L13.6025456,15.7832412 C13.7357375,15.8498372 13.8689295,15.9164331 14.0021214,15.9164331 C14.0687173,15.9164331 14.2019092,15.9164331 14.2685052,15.8498372 C14.468293,15.7832412 14.6680809,15.5168574 14.6680809,15.3170695 L16,0.665959545 L16,0.599363591" id="路径"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`
}}/>


export const messageType = {
    USER: 'USER',
    SYSTEM: 'SYSTEM',
    ACTION: 'ACTION',
    CHANGE_THEME: 'CHANGE_THEME',
    EDIT: "EDIT",
    THEME_REVOCATION: "THEME_REVOCATION",
    CUSTOM: "CUSTOM"
};
const renderMessage = (props) => {
    const {id, type, open, customComponent} = props;
    let Component;
    switch (type) {
        case messageType.USER: {
            Component = UserChartContainerComponent;
            break;
        }
        case messageType.SYSTEM: {
            Component = SystemChartComponent;
            break;
        }
        case messageType.CHANGE_THEME: {
            Component = ChangeThemeComponent;
            break;
        }
        case messageType.EDIT: {
            Component = EditComponent;
            break;
        }
        case messageType.THEME_REVOCATION: {
            Component = ThemeRevocationComponent;
            break;
        }
        case messageType.CUSTOM: {
            return props.props.customComponent
        }
    }
    return <Component id={id} type={type} open={open} {...props.props}/>
}
const UserChartContainerComponent = withComponent((props) => {
    const {value} = props;
    return <UserChatBoxPositionStyled>
        <UserChatBoxStyled>
            <UserChatTextStyled>
                {value}
            </UserChatTextStyled>
        </UserChatBoxStyled>
    </UserChatBoxPositionStyled>
})
const SystemChartComponent = withComponent((props) => {
    const {value, children} = props;
    return <SystemChatBoxStyled>
        <SystemChatTextStyled>
            {value || children}
        </SystemChatTextStyled>
    </SystemChatBoxStyled>
});
const ChangeThemeComponent = withComponent((props) => {
    const {onClickNoChangeTheme, onClickChangeThemeByIndex} = props;
    const theme = useSelector(state => state.theme);
    return <DivStyled8>
        {theme?.colorList?.slice?.(0, 7).map?.((color, index) => {
            return <DivStyled9 onClick={() => onClickChangeThemeByIndex({color, index})}
                               style={{backgroundColor: color, marginRight: 15}}/>
        })}
        <DivStyled10 onClick={onClickNoChangeTheme}>
            不换
        </DivStyled10>
    </DivStyled8>
});
const EditComponent = withComponent((props) => {
    const {inputRef, onChange, onKeyDown, onClickSend, title, id} = props;
    const [value, setValue] = useState();
    const [disable, setDisable] = useState(false);
    const onChange$1 = useCallback((e) => {
        setValue(e.target.value);
        onChange(e);
    }, []);
    const send = () => {
        setDisable(true)
        inputRef?.current?.blur?.()
        onClickSend();
    }
    const keyDown = (e) => {
        return
        if (e.keyCode === 13) {
            setDisable(true)
            inputRef?.current?.blur?.();
        }
        onKeyDown(e)
    }
    return <DivStyled11 id={"chat-edit-" + id} ref={(container) => {
        if (container) {
            container.setDisable = setDisable;
        }
    }} style={{pointerEvents: disable ? "none" : undefined, opacity: disable ? 0.5 : undefined}}>
        <DivStyled12>{title}</DivStyled12>
        <DivStyled16>
            <DivStyled13 ref={inputRef} onChange={onChange$1} onKeyDown={keyDown}
                         placeholder="我叫张了了，性别女，有3年产品经理经验,  毕业于....."/>
            <div style={{ height: 38, width: '100%' }} />
            {
                !disable && <Popover className="ant-popover-custom"
                                     overlayClassName="ant-popover-custom"
                                     content={<HintComponent/>}
                                     trigger='hover'
                                     style={{width: 228}}
                >
                    <DivStyled14>查看示例</DivStyled14>
                </Popover>
            }
            {
                !disable && <DivStyled15 onClick={!!value ? send : undefined}
                                         style={{backgroundImage: !!value ? "url(https://oss.jianzeppt.com/user/3394743/e41fe013-1d23-4692-9b70-28f6f9d87cfc.png)" : undefined}}/>
            }
        </DivStyled16>

    </DivStyled11>
});
const HintComponent = withComponent(() => {
    const text = "我是张三，联系方式是13800138000和zhangsan@email.com。我住在北京朝阳区某某路。\n" +
        "我希望找一个数据分析师的职位。我在北京大学获得数学与应用数学的硕士学位，毕业时间是2021年6月。\n" +
        "我从2020年7月到2021年6月在阿里巴巴担任数据分析实习生，我主要负责数据清洗和模型构建。\n" +
        "技能方面，我熟练掌握Python编程，并已获得数据分析师证书；兴趣爱好包括踢足球和旅行。\n" +
        "另外，我在大学时期曾获得“国家奖学金”，并有一篇关于数据分析的论文发表在知名学术期刊上。"
    const onClickCopy = () => {
        navigator.clipboard.writeText(text).then(() => {
            message.success("复制成功")
        }).catch(() => {
            message.error("复制失败，请在浏览器中设置权限")
        })
    }
    return <DivStyled17>
        <DivStyled18 onClick={onClickCopy}/>
        {text}
    </DivStyled17>
})
const ThemeRevocationComponent = withComponent((props) => {
    const {color, onClickRevocation} = props;
    const [state, setState] = useState(false);
    const onClick = () => {
        setState(true)
        onClickRevocation()
    }
    return <SystemChartComponent>
        <div>好的，模板主色已换成<DivStyled9
            style={{backgroundColor: color, margin: "0 4px", display: "inline-block", position: "relative", top: 4}}/>色，
            看看效果吧！<DivStyled20 onClick={onClick}><img
                src={state ? "https://jianzeppt-backend-shanghai.oss-cn-shanghai.aliyuncs.com/jz-ppt-img/gou.png" : "https://jianzeppt-backend-shanghai.oss-cn-shanghai.aliyuncs.com/jz-ppt-img/backback2.png"}
                width={12}
                height={12} style={{marginRight: 3}}/>{state ? '已撤销' : '撤销'}</DivStyled20></div>
    </SystemChartComponent>
})


const ChatLoading = withComponent((props) => {
    const {loading, scrollBottom} = props;
    return <ChatItemLayoutStyled style={{visibility: loading ? undefined : 'hidden', marginTop: 0}}>
        <SystemChartComponent value={<img width={65} height={22}
                                          src='https://oss.jianzeppt.com/user/4556/dd606090-e1a4-4579-9034-1de2e9f80e3d.gif'/>}/>
    </ChatItemLayoutStyled>
});

const ActionC = (props) => {
    const {id, aiDecision, isModifyText} = props;
    const [, update] = useForceUpdate();
    const that = useRef({
        originAiDecision: JSON.parse(JSON.stringify(aiDecision))
    }).current;
    const [open, setOpen] = useState(false)
    const resumeDetailInstance = useResumeDetailInstance();
    useClickOutside({
        enable: that.originAiDecision.some(aiDecision => !aiDecision.status),
        whiteList: [`#ai-decision-${id}`, '.ai-decision-mask', '.ai-decision-action'],
        callback: () => {
            setOpen(true)
        }
    })
    const onClickS = useCallback((currentAiDecision, disabledMsg = false) => {
        resumeDetailInstance?.resumeRef?.current?.aiDecision?.onClickSuccess?.(currentAiDecision, disabledMsg);
        changeStatus(currentAiDecision, "success")
    }, []);
    const onClickC = useCallback((currentAiDecision, disabledMsg = false) => {
        resumeDetailInstance?.resumeRef?.current?.aiDecision?.onClickCancel?.(currentAiDecision, disabledMsg);
        changeStatus(currentAiDecision, "revocation")
    }, []);

    const onClickAllS = () => {
        that.originAiDecision.forEach(aiDecision => !aiDecision.status && onClickS(aiDecision, true))
        console.log('触发了这个位置3')
        message.success({
            content: "内容已保留！", className: "theme-message-default"
        })
    }
    const onClickAllC = () => {
        that.originAiDecision.forEach(aiDecision => !aiDecision.status && onClickC(aiDecision, true))
        message.success({
            content: "内容已撤销！", className: "theme-message-dark"
        });
    }
    const changeStatus = useCallback((currentAiDecision, status) => {
        if (status === "success") {
            currentAiDecision.status = "success";
            update();
            setTimeout(() => {
                currentAiDecision.statusF = 1;
                update();
            }, 3000)
        } else {
            currentAiDecision.status = "revocation";
            setTimeout(() => {
                currentAiDecision.statusF = 1;
                update();
            }, 3000)
            update();
        }

    }, []);
    const handleOk = () => {
        onClickAllS()
        setOpen(false)
    }
    const handleCancel = () => {
        onClickAllC()
    }
    const refHandler = useCallback((container) => {
        if (container) {
            container.instance = that;
        }
    }, []);
    useMemo(() => {
        that.changeStatus = changeStatus;
    }, [])

    useEffect(() => {

    }, [])


    return <DivStyled1 id={`ai-decision-${id}`} ref={refHandler}>
        <DivStyled5>{isModifyText ? "优化简历完成，您可以保存或修改内容：" : "识别到您的内容会在以下模块里："}</DivStyled5>
        <DivStyled4>(您可在左侧对应模块里选择保留或撤回填充的内容，选择后将不会保留，需重新输入)</DivStyled4>
        <div>
            {that.originAiDecision.map((aiDecision) => {
                let des = getTextBySlot(aiDecision.blockName, aiDecision.slotName);
                if (aiDecision.moduleContentIndex !== undefined) {
                    des = `第${Number(aiDecision.moduleContentIndex) + 1}段`
                }
                return <DivStyled2>
                    <img src={getIconByModule(aiDecision.blockName)} width={20} height={20}
                         style={{marginLeft: 14, marginRight: 8}}/>
                    <DivStyled3>{getTextByModule(aiDecision.blockName)} ：{des}</DivStyled3>
                    {aiDecision.status ? <DivStyled7>
                        {aiDecision.status === "success" ? <>
                            <img
                                src="https://oss.jianzeppt.com/jz-ppt-img/jkvcnvkjdfnkjfd.png"
                                width={12} height={12}
                                style={{marginRight: aiDecision.statusF === 1 ? undefined : 6, marginTop: 4}}/>
                            {aiDecision.statusF !== 1 && <span style={{color: "#66D3C5"}}>已保留</span>}
                        </> : <>
                            <img
                                src="https://oss.jianzeppt.com/jz-ppt-img/mfdndsjknoqolk.png"
                                width={12} height={12}
                                style={{marginRight: aiDecision.statusF === 1 ? undefined : 6, marginTop: 4}}/>
                            {aiDecision.statusF !== 1 && <span style={{color: "#D3D3D3"}}>已撤销</span>}
                        </>}
                    </DivStyled7> : <>
                        <DivStyled7>
                            <div onClick={() => onClickC(aiDecision)} style={{marginRight: 12}}>{undoIcon}</div>
                            <div onClick={() => onClickS(aiDecision)}>{redoIcon}</div>
                        </DivStyled7>
                    </>}
                </DivStyled2>
            })}
        </div>
        {
            that.originAiDecision.some(aiDecision => !aiDecision.status) && <FlexStyled style={{ paddingTop: 16 }}>
                <JzButton onClick={onClickAllC} style={{ marginRight: 4}}><JzButtonIcon>{undoIcon}</JzButtonIcon>全部撤销</JzButton>
                <JzButton onClick={onClickAllS}  $type="primary"><JzButtonIcon $fill="#FFFFFF">{redoIcon}</JzButtonIcon>全部应用</JzButton>
            </FlexStyled>
        }
        <Dialog
            type="warning"
            width={400}
            open={open}
            titleText='AI提示'
            descText='您是否保留当前AI生成的内容？'
            onCancel={() => setOpen(false)}
            onBtnCancel={handleCancel}
            onOk={handleOk}
            cancelText={<>
                {undoIcon} <div style={{ marginLeft: 6 }}>撤销</div>
            </>}
            okText={<>
                {whiteRedoIcon} <div style={{ marginLeft: 6 }}>保留</div>
            </>}
        />
    </DivStyled1>
}

export default (props) => {
    const {
        store, 
        setResumeLoading,
        setThemeVisible,
        setChangeTemplateVisible
    } = props;
    const that = useRef({
        messages: [],
        scrollBottomFlag: false,
        searchLoading: false,
        aiDecisionPending: [],
        userFetchLoadingMessageIdQueue: []
    }).current;
    const cancelRef = useRef(new AbortController())
    const inputRef = useRef();
    const scrollRef = useRef();
    const [, update] = useForceUpdate();
    const aiDecision = useResumeSelector((state) => state.aiDecision);
    const [searchLoading, setSearchLoading] = useState(false)
    const [open, setOpen] = useState(false)
    const resumeDetailInstance = useResumeDetailInstance();
    useClickOutside({
        enable: searchLoading,
        whiteList: [],
        callback: () => {
            setOpen(true)
        }
    })
    const onTransitionEnd = useCallback(() => {

    }, [])
    const pushMessage = useCallback((value) => {
        that.messages.push(value);
        that.messages = [...that.messages];
        update();
    }, []);
    const clearMessage = useCallback((remainLength = 3) => {
        that.messages = that.messages.slice(0, remainLength)
        update()
    })
    const onChange = useCallback((e) => {
        changeValue(e.target.value);
    }, []);
    const changeValue = useCallback((value) => {
        that.inputValue = value;
        update();
    }, []);
    const userSearch = useCallback(async (value) => {
        if (that.loading || !value) return false;
        const id = v4();
        that.userFetchLoadingMessageIdQueue.push(id)
        const index = that.messages.findLastIndex(msg => msg.type === messageType.EDIT)
        if (index !== -1) {
            clearMessage(index)
        }
        pushMessage({id: v4(), type: messageType.USER, props: {value}});
        await sleep(500)
        pushMessage({id: v4(), type: messageType.SYSTEM, props: {value: "已了解到您的信息，正在为您识别内容中..."}});
        await search(value);

    }, []);
    const onKeyDown = useCallback((e) => {
        if (e.keyCode === 13) {
            userSearch(that.inputValue);
            that.inputValue = undefined;
        }
    }, []);
    const onClickSend = useCallback(() => {
        const value = that.inputValue
        return userSearch(value);
    }, []);
    const messagesElement = useMemo(() => {
        return that.messages.map((message) => {
            return <TranlateBox key={message.id} id={message.id} delayTime={200}
                                initAnimation={message?.props?.initAnimation}
                                onTransitionEnd={onTransitionEnd}>
                <ChatItemLayoutStyled>
                    {renderMessage({...message})}
                </ChatItemLayoutStyled>
            </TranlateBox>;
        })
    }, [that.messages]);
    const deleteMessageById = useCallback((id) => {
        const index = that.messages.findIndex((item) => item.id === id);
        if (index !== -1) {
            that.messages.splice(index, 1);
            that.messages = [...that.messages];
            update()
        }
    }, [])
    const scrollBottom = () => {
        if (!scrollRef.current) return;
        scrollRef.current.scrollToBottom();
    };
    const search = async (value) => {
        try {
            setResumeLoading(true);
            setSearchLoading(true)
            cancelRef.current = new AbortController()
            that.searchLoading = true;
            update()
            const {resumeData, resume} = store.getState();
            const conversationList = that.messages.filter((item) => item.type2 === messageType.SYSTEM).map((item) => item.id);
            const res = await modifyResume({
                body: {
                    id: resume.resumeId,
                    conversationList, text: value, resumeBody: {userData: getResumeDataExcludeIcon(resumeData)}
                },
                config: {
                    signal: cancelRef.current.signal
                }
            })
                .catch((err) => {
                })
                .finally(() => {
                    setOpen(false)
                    that.searchLoading = false;
                    setResumeLoading(false);
                    setSearchLoading(false)
                    update();
                })
            processModifyResume(res)
        } catch (e) {
            if (e) {
                message.error(e)
            }
            setSearchLoading(false)
        }
    };
    useEffect(() => {
        const testResume = window.localStorage.getItem('testResume')
        // if (testResume) {
        //     processModifyResume(testResume)
        // }
    }, [])
    // 基于目标岗位优化简历
    const customMessage = async (callback) => {
        // clearMessage()
        pushMessage({
            id: v4(),
            type: messageType.USER,
            props: {value: "基于目标岗位帮我优化简历", initAnimation: false}
        });
        await sleep(500)
        pushMessage({
            id: v4(),
            type: messageType.SYSTEM,
            props: {
                value: "发现您尚未完善简历哦，是否继续优化简历？",
                initAnimation: true
            }
        });
        await sleep(500)
        let customId = v4()
        pushMessage({
            id: customId,
            type: messageType.CUSTOM,
            props: {
                customComponent: <SelectNextCard
                    onChange={async (type) => {
                        if (type === 'continue') {
                            callback && callback(true)
                            const index = that.messages.findIndex(msg => msg.id === customId)
                            if (index !== -1) {
                                clearMessage(index + 1)
                            }
                            pushMessage({
                                id: v4(),
                                type: messageType.USER,
                                props: {value: "我要继续优化", initAnimation: false}
                            });
                            await sleep(500)

                            pushMessage({
                                id: v4(),
                                type: messageType.SYSTEM,
                                props: {
                                    value: "已了解到您的岗位描述和职位要求，即将为您优化简历",
                                    initAnimation: true
                                }
                            });
                        } else if(type === 'edit'){
                            const index = that.messages.findIndex(msg => msg.id === customId)
                            if (index !== -1) {
                                clearMessage(index + 1)
                            }
                            pushMessage({
                                id: v4(),
                                type: messageType.USER,
                                props: {value: "我要完善简历", initAnimation: false}
                            });
                            await sleep(500)

                            pushMessage({
                                id: v4(),
                                type: messageType.EDIT,
                                props: {
                                    inputRef: inputRef,
                                    onChange,
                                    onKeyDown,
                                    onClickSend,
                                    title: "输入内容，完善简历！"
                                }
                            })
                        } else  {
                            handleChangeCard(type)
                        }
                    }}
                />,
                initAnimation: true
            }
        });
    }
    // 基于面试问题优化简历
    const customMessageWithInterview = async (callback) => {
        // clearMessage()
        pushMessage({
            id: v4(),
            type: messageType.USER,
            props: {value: "基于目标岗位帮我生成面试问题", initAnimation: false}
        });
        await sleep(500)
        pushMessage({
            id: v4(),
            type: messageType.SYSTEM,
            props: {
                value: "发现您尚未完善简历哦，是否继续生成面试问题？",
                initAnimation: true
            }
        });
        await sleep(500)
        let customId = v4()
        pushMessage({
            id: customId,
            type: messageType.CUSTOM,
            props: {
                customComponent: <SelectNextCard
                    customOption={[
                        { type: 'edit', label: '完善简历', src: "airesume_custom1.png", bgSrc: "airesumebg3.png", color: '#5E658E'},
                        { type: 'continue', label: '我要生成面试问题', src: "airesume_custom2.png", bgSrc: "airesumebg4.png", color: '#5E658E'},
                    ]}
                    onChange={async (type) => {
                        if (type === 'continue') {
                            const index = that.messages.findIndex(msg => msg.id === customId)
                            if (index !== -1) {
                                clearMessage(index + 1)
                            }
                            pushMessage({
                                id: v4(),
                                type: messageType.USER,
                                props: {value: "我要生成面试问题", initAnimation: false}
                            });

                            callback && callback(true)
                            await sleep(500)
                            pushMessage({
                                id: v4(),
                                type: messageType.SYSTEM,
                                props: {
                                    value: "已了解到您的岗位描述和职位要求，即将为您生成面试问题",
                                    initAnimation: true
                                }
                            });
                        } else if(type === 'edit'){
                            const index = that.messages.findIndex(msg => msg.id === customId)
                            if (index !== -1) {
                                clearMessage(index + 1)
                            }
                            pushMessage({
                                id: v4(),
                                type: messageType.USER,
                                props: {value: "我要完善简历", initAnimation: false}
                            });
                            await sleep(500)
                            pushMessage({
                                id: v4(),
                                type: messageType.EDIT,
                                props: {
                                    inputRef: inputRef,
                                    onChange,
                                    onKeyDown,
                                    onClickSend,
                                    title: "输入内容，完善简历！"
                                }
                            })
                        } else  {
                            handleChangeCard(type)
                        }
                    }}
                />,
                initAnimation: true
            }
        });
    }
    const processModifyResume = async (res, isModifyText, disableContinue) => {
        if (!res) {
            const target = that.messages.findLast((item) => item.type === "EDIT");
            if (target) {
                document.getElementById("chat-edit-" + target.id).setDisable(false)
            }
        } else {
            const {text, resumeBody, conversationId} = res;
            const {userData, changePart} = resumeBody || {};
            let timeout = 0;
            if (text) {
                pushMessage({
                    id: conversationId, type: messageType.SYSTEM, type2: messageType.SYSTEM, props: {value: text}
                });
                timeout += 1000;
            }
            if (userData || changePart) {
                message.success({
                    content: "内容填充完成！", className: "theme-message-default"
                })
                const {resumeData} = store.getState();
                if (changePart) {
                    changePart.forEach((item) => {
                        const fieldName = getFieldBySlot(item.blockName, item.slotName);
                        if (item.moduleContentIndex !== undefined && item.moduleContentIndex !== null) {
                            const path = getResumePath(item.blockName, undefined, undefined, item.moduleContentIndex);
                            item.originValue = getNestedProperty(resumeData, path);
                            item.id = v4();
                            item.fieldName = fieldName;
                        } else {
                            const path = getResumePath(item.blockName, undefined, item.slotName, undefined);
                            item.originValue = getNestedProperty(resumeData, path);
                            item.id = v4();
                            item.fieldName = fieldName;
                        }
                    })
                    store.dispatch(resumeDataSlice.actions.set(userData));
                    resumeDetailInstance.resumeRef?.current?.aiDecision?.setAiDecision?.(changePart);
                    const id = v4();
                    setTimeout(() => {
                        pushMessage({
                            id, type: messageType.SYSTEM, props: {
                                value: <ActionC isModifyText={isModifyText} id={id} aiDecision={changePart}/>, typing: true
                            }
                        });
                    }, timeout)
                    timeout += 1000;
                    that.aiDecisionPending.push({
                        id, changePart: changePart,
                    });
                } else {
                    store.dispatch(resumeDataSlice.actions.set(userData));
                }

                let count = 0
                let timerId = setInterval(() => {
                    const els = document.querySelectorAll('.ai-decision-mask')
                    if (els && els.length > 0) {
                        const newEls = Array.from(els)
                        newEls.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top)
                        newEls?.[0]?.click()
                        clearTimeout(timerId)
                    }
                    if (count > 10) {
                        clearTimeout(timerId)
                    }
                    count++
                }, 200)
            }
            setTimeout(async () => {
                if (!disableContinue) {
                    pushMessage({
                        id: v4(),
                        type: messageType.SYSTEM,
                        props: {
                            value: "发现您的简历存在未修改项目哦...",
                            initAnimation: true
                        }
                    });
                    await sleep(1000)
                    pushMessage({
                        id: v4(),
                        type: messageType.EDIT,
                        props: {
                            inputRef: inputRef,
                            onChange,
                            onKeyDown,
                            onClickSend,
                            title: "您可以在左侧修改，或者在下方输入内容，AI帮你调整！"
                        }
                    });
                }
                await sleep(1000)
                const customId = v4()
                pushMessage({
                    id: customId,
                    type: messageType.CUSTOM,
                    props: {
                        customComponent: <SelectCard titleText="继续选择你的操作：" onChange={(type) => {
                            const index = that.messages.findIndex(msg => msg.id === customId)
                            if (index !== -1) {
                                clearMessage(index + 1)
                            }
                            handleChangeCard(type)
                        }} />,
                        initAnimation: true
                    }
                });
            }, timeout)
        }
    }
    window.processModifyResume = processModifyResume
    window.customMessage = customMessage
    window.customMessageWithInterview = customMessageWithInterview
    window.customMessageWithInterviewSuccess = async () => {
        pushMessage({
            id: v4(),
            type: messageType.SYSTEM,
            props: {
                value: "面试问题生成完成，您可以在左侧回答并查看面试建议",
                initAnimation: true
            }
        });
        await sleep(500)
        const customId = v4()
        pushMessage({
            id: customId,
            type: messageType.CUSTOM,
            props: {
                customComponent: <SelectCard titleText="继续选择你的操作：" onChange={(type) => {
                    const index = that.messages.findIndex(msg => msg.id === customId)
                    if (index !== -1) {
                        clearMessage(index + 1)
                    }
                    handleChangeCard(type)
                }} />,
                initAnimation: true
            }
        });
    }

    const verifyAiDecision = useCallback(() => {
        let currentDecision;
        const {aiDecision: storeDecision} = store.getState()
        if (that.aiDecisionPending.length >= 1) {
            currentDecision = that.aiDecisionPending[that.aiDecisionPending.length - 1];
            let preDecisions = that.aiDecisionPending.slice(0, -1);
            preDecisions.forEach((item, index) => {
                const instance = document.getElementById(`ai-decision-${item.id}`)?.instance;
                if (instance) {
                    instance.originAiDecision.filter((item) => item.status === undefined).forEach((item) => {
                        instance.changeStatus(item, "success")
                    })
                }
            });
            that.aiDecisionPending = that.aiDecisionPending.slice(-1);
        }
        if (currentDecision) {
            const instance = document.getElementById(`ai-decision-${currentDecision.id}`)?.instance;
            if (instance) {
                currentDecision.changePart.forEach((item) => {
                    const storeDecisionItem = storeDecision?.find?.((i) => i.id === item.id);
                    if (storeDecisionItem && storeDecisionItem.status && item.status === undefined) {
                        if (instance) {
                            const target = instance.originAiDecision.find((item) => item.id === storeDecisionItem.id);
                            if (target) {
                                instance.changeStatus(target, storeDecisionItem.status)
                            }
                        }
                    } else if (!storeDecisionItem) {
                        if (instance && instance.originAiDecision) {
                            instance.originAiDecision.forEach((item) => {
                                if (item.status === undefined) {
                                    instance.changeStatus(item, "success")
                                }
                            })
                        }
                    }
                })
                const isAll = currentDecision.changePart.every((item) => {
                    const storeDecisionItem = storeDecision?.find?.((i) => i.id === item.id);
                    return storeDecisionItem && storeDecisionItem.status && item.status !== undefined
                });
                if (isAll) {
                    that.aiDecisionPending = []
                }
            }
        }
    }, []);
    const onClickRevocation = useCallback(() => {
        resumeDetailInstance.resumeRef?.current?.changeThemeWithSave?.();
    }, [])
    const onClickChangeThemeByIndex = useCallback(({color, index}) => {
        resumeDetailInstance.resumeRef?.current?.changeThemeWithSave?.(index);
        const item = that.messages.find((item) => item.type === messageType.CHANGE_THEME);
        if (item) {
            deleteMessageById(item.id);
        }
        pushMessage({
            id: v4(),
            type: messageType.USER,
            props: {
                value: <FlexStyled>我想把主题换成<DivStyled9
                    style={{backgroundColor: color, margin: "0 4px"}}/>色</FlexStyled>,
                initAnimation: false
            }
        });
        setTimeout(() => {
            pushMessage({
                id: v4(),
                type: messageType.THEME_REVOCATION,
                props: {initAnimation: true, color, onClickRevocation}
            });
        }, 500)
        setTimeout(() => {
            pushMessage({
                id: v4(),
                type: messageType.EDIT,
                props: {
                    inputRef: inputRef,
                    onChange,
                    onKeyDown,
                    onClickSend,
                    title: "开始撰写你的简历吧！请输入您的简历内容："
                }
            });
        }, 1500)

    }, []);
    const onClickNoChangeTheme = useCallback(() => {
        const item = that.messages.find((item) => item.type === messageType.CHANGE_THEME);
        deleteMessageById(item.id);
        pushMessage({
            id: v4(),
            type: messageType.USER,
            props: {value: "不换，我要保留原模板颜色", initAnimation: false}
        });
        setTimeout(() => {
            pushMessage({
                id: v4(),
                type: messageType.EDIT,
                props: {
                    inputRef: inputRef,
                    onChange,
                    onKeyDown,
                    onClickSend,
                    title: "开始撰写你的简历吧！请输入您的简历内容："
                }
            });
        }, 500)
    }, [])

    const handleResumeStyler = (type) => {
        if (type === 'color') {
            setThemeVisible(true)
        } else if (type === 'template') {
            setChangeTemplateVisible(true)
        }
    }

    const handleChangeCard = async (type, callback) => {
        // beautify:美化 | edit: 完善简历 | interview: 面试建议 | upload:上传简历
        if (type === 'edit') {
            // clearMessage()
            pushMessage({
                id: v4(),
                type: messageType.USER,
                props: {value: "我要完善简历", initAnimation: false}
            });
            await sleep(500)
            pushMessage({
                id: v4(), 
                type: messageType.SYSTEM, 
                props: {value: "好的，请在下方描述你的工作历程，我会帮你生成简历！"}
            });
            await sleep(500)
            pushMessage({
                id: v4(),
                type: messageType.EDIT,
                props: {
                    inputRef: inputRef,
                    onChange,
                    onKeyDown,
                    onClickSend,
                    title: "开始撰写你的简历吧："
                }
            });
        } else if (type === 'interview') {
            window.generateInterviewByJd()
        } else if (type === 'upload') {
            window.triggerUploadFile()
        } else if (type === 'jd') {
            // await sleep(500)
            window.modifyResumeByJd()
        } else if (type === 'continue') {
            // callback && callback()
        }

    }

    const handleOk = () => {
        cancelRef.current.abort()

        setOpen(false)
        setResumeLoading(false)
        message.destroy()
    }


    useEffect(() => {
        scrollBottom();
    }, [that.messages, that.searchLoading]);
    useEffect(() => {
        const initMessageList = async () => {
            await sleep(1000)
            pushMessage({
                id: v4(), type: messageType.SYSTEM, props: {
                    value: <FlexStyled>
                        {/* <div style={{marginRight: 8}}>{helpIcon}</div> */}
                        <div>{helpIcon}👋🏻Hi～，欢迎使用智能简历编辑器，我是您的AI助手。无论您追求的是哪种职业道路，我都能根据您的独特经历和目标岗位，量身定制您的简历，并提供针对性的面试准备指导。帮您在职场竞争中脱颖而出。</div>
                    </FlexStyled>, initAnimation: true
                }
            });
            await sleep(1000)
            pushMessage({
                id: v4(), type: messageType.SYSTEM, props: {
                    value: <FlexStyled>
                        <div>现在，让我们开始吧！选择一个你想要开始的功能，我会帮你打造一份专业且个性化的简历。</div>
                    </FlexStyled>, initAnimation: true
                }
            });
            let customId = v4()
            pushMessage({
                id: customId,
                type: messageType.CUSTOM, 
                props: {
                    customComponent: <SelectCard onChange={(type) => {
                        const index = that.messages.findIndex(msg => msg.id === customId)
                        if (index !== -1) {
                            clearMessage(index + 1)
                        }
                        handleChangeCard(type)
                    }} />,
                    initAnimation: true
                }
            });
        }

        initMessageList()
    }, []);
    useEffect(() => {
        verifyAiDecision()
    }, [aiDecision]);


    return <ContainerStyled>
        <MessageContainerStyled>
            <Scrollbars ref={scrollRef} autoHide>
                <MessageScrollContainerStyled>
                    {messagesElement}
                    <ChatLoading loading={that.searchLoading}/>
                </MessageScrollContainerStyled>
            </Scrollbars>
        </MessageContainerStyled>

        <Dialog
            type="error"
            width={400}
            open={open}
            titleText='AI正在为您生成中，是否终止'
            descText='注意：此操作将计入您的AI使用额度'
            onCancel={() => setOpen(false)}
            onOk={handleOk}
            cancelText={<>
                <div style={{ marginLeft: 6 }}>取消</div>
            </>}
            okText={<>
                <div style={{ marginLeft: 6 }}>确定</div>
            </>}
        />
    </ContainerStyled>
}


